import { useQuery } from "@tanstack/react-query";
import {
    getPredictionStatus,
    getCompletionForecast,
    getBudgetTrajectory,
    getPhaseDistribution,
    getTimelineData,
} from "../api";

export const usePredictionStatus = () => {
    return useQuery({
        queryKey: ["visionStudio", "predictionStatus"],
        queryFn: getPredictionStatus,
    });
};

export const useCompletionForecast = () => {
    return useQuery({
        queryKey: ["visionStudio", "completionForecast"],
        queryFn: getCompletionForecast,
    });
};

export const useBudgetTrajectory = () => {
    return useQuery({
        queryKey: ["visionStudio", "budgetTrajectory"],
        queryFn: getBudgetTrajectory,
    });
};

export const usePhaseDistribution = () => {
    return useQuery({
        queryKey: ["visionStudio", "phaseDistribution"],
        queryFn: getPhaseDistribution,
    });
};

export const useTimelineData = () => {
    return useQuery({
        queryKey: ["visionStudio", "timelineData"],
        queryFn: getTimelineData,
    });
};
